import { Radio, RadioCardProps, RadioGroupProps, RadioProps } from '@mantine/core';

import classes from './Radio.module.css';

const RadioDefaults = Radio.extend({
  classNames: {
    root: classes.root,
    body: classes.body,
    inner: classes.inner,
    radio: classes.radio,
    icon: classes.icon,
    label: classes.label,
  },
  defaultProps: {
    size: 'md',
  },
});

const RadioIndicatorDefaults = Radio.Indicator.extend({
  classNames: {
    indicator: classes.indicator,
    icon: classes.indicatorIcon,
  },
  defaultProps: {
    size: 'md',
  },
});

export { RadioDefaults, RadioIndicatorDefaults, Radio as RadioMantine };
export type { RadioCardProps, RadioGroupProps, RadioProps };
